import { render, staticRenderFns } from "./RegisterMain.vue?vue&type=template&id=76aeaa3e&scoped=true&"
import script from "./RegisterMain.vue?vue&type=script&lang=js&"
export * from "./RegisterMain.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMain.vue?vue&type=style&index=0&id=76aeaa3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aeaa3e",
  null
  
)

export default component.exports